import { z } from "zod";
import {
  KycSchema,
  PreReviewDocumentSchema,
  TREEZOR_KYC_LIVENESS_STATUSES,
  TREEZOR_KYC_LIVENESS_USER_REASON_CODES,
  UserSchema,
} from "../treezor/index.js";

export default {
  params: z.object({
    accountId: z.string(),
  }),
  response: z.object({
    user: UserSchema.extend({ kyc: KycSchema.optional() }),
    kycLivenessStatus: z.enum(TREEZOR_KYC_LIVENESS_STATUSES),
    kycLivenessReasonCodes: z.array(z.enum(TREEZOR_KYC_LIVENESS_USER_REASON_CODES)),
    kycLivenessStartedAt: z.number().nullable(),
    powerOfAttorneyDocument: PreReviewDocumentSchema.nullable(),
  }),
};
